export default __webpack_public_path__ + "static/media/notFound.676fef04.jpg";